<template>
    <section class="key-indicators">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate"></title-date-component>
        <section class="indicators-data-box">
            <indicators-data-component v-for="(item, index) in indicatorsData" :data="item" :key="index"></indicators-data-component>
        </section>
        <tips-component :info="info"></tips-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .key-indicators {
        background-color: #FFF;
        padding: 30px 20px 10px 20px;
        margin-top: 15px;
    }
    .indicators-data-box {
        margin-top: 36px;
        padding-left: 15px;
    }
</style>

<script>
    import TitleDateComponent from '../../../components/title-date/TitleDate.vue'
    import IndicatorsDataComponent from '../../../components/indicators-data/IndicatorsData.vue'
    import TipsComponent from '../../../components/tips/Tips.vue'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../../../filters/moment-format'

    export default {
        components: {
	        TitleDateComponent,
	        IndicatorsDataComponent,
	        TipsComponent
        },
        data () {
            return {
                titleOption: {  // 单元块名称和日期选择配置
                	title: '关键指标',  // 名称
                    dateRadio: true,    // 是否显示昨天、本周、本月日期单选框
                    dateRangeSelect: false, // 是否显示日期区间下拉框
                    download: false // 是否显示下载按钮
                },
	            startDate: MomentFormat.getYestoday(),  // 开始日期，默认昨天
	            endDate: MomentFormat.getYestoday(), // 结束日期，默认昨天
	            initDateRange: MomentFormat.getYestoday() + ' ~ ' + MomentFormat.getYestoday(),
	            data: this.resultData
            }
        },
	    computed: {
		    // 单个指标数据
		    indicatorsData () {
			    return {
				    pageViews: {
					    name: '商家拒单率',
					    value: this.data.rejectRate,
					    unit: '%',
					    compare: this.data.rejectRateChg,
					    title: '商家拒单订单数/支付订单数'
				    },
				    visitors: {
					    name: '用户退款率',
					    value: this.data.refundRate,
					    unit: '%',
					    compare: this.data.refundRateChg,
					    title: '用户申请退款的订单数/支付订单数'
				    }
			    }
		    },

		    // 底部建议
		    info () {
			    return {
				    value: this.data.rejectRateChg,
				    title: "您的拒单率与上一周期相比",
				    suggest: "提升服务降低拒单率，会对您商品的流量有稳步提升的效果，请重点关注。",
                    reverse: true   // 表情反向显示
			    }
		    }
	    },
	    props: ["resultData", "bizCode"],
	    watch: {
		    resultData: {
			    handler: function () {
				    this.data = this.resultData;
			    },
			    deep: true
		    }
	    },
        methods: {
	        getData () {
		        DataPlatform.getOperationData(this.bizCode, this.startDate, this.endDate)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.data = res.data;
                        } else {
                            this.data = {};
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        this.data = {};
                        console.log(err);
                    })
	        },

	        // 切换日期
	        changeDate (params) {
		        this.startDate = params.dateRange.startDate;
		        this.endDate = params.dateRange.endDate;
		        this.getData();
	        }
        }
    }
</script>



// WEBPACK FOOTER //
// KeyIndicators.vue?f0aebbf6